const enum BaseCheckboxVariant {
  default = 'default',
  radio = 'radio',
  check = 'check',
  toggle = 'toggle',
}

export default BaseCheckboxVariant
